<template>
  <div class="gui-flex gui-flex-rows">
    <div class="mb-3 no__radius">
      <v-snackbar
        v-model="snackbar"
        :timeout="3000"
        :top="true"
        dark
        large
        :color="inserted ? 'green darken-2': 'red darken-2'"
      >
        <span v-if="inserted">Úspěšně uloženo</span>
        <span v-else>Neuloženo</span>
      </v-snackbar>
      <v-layout row wrap class="mt-5">
        <v-flex xs12 sm6 offset-sm3 md4 offset-md4>
          <v-card>
            <v-card-text class="pa-4">
              <v-form lazy-validation ref="form" v-model="valid">
                <h2 class="mx-2">Nová platba</h2>
                <v-layout row wrap class="mt-2">
                  <v-flex xs12>
                    <ucty v-model="newItem.ucet_id"></ucty>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 sm8>
                    <v-text-field
                      label="Částka"
                      v-model="newItem.castka"
                      class="mx-2"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <meny v-model="newItem.mena_id" class="mx-2"></meny>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      label="Protiúčet"
                      v-model="newItem.protiucet"
                      class="mx-2"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      label="Variabilní symbol"
                      v-model="newItem.variabilni_symbol"
                      class="mx-2"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      label="Poznámka"
                      v-model="newItem.poznamka"
                      class="mx-2"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 class="text-xs-center">
                    <v-btn color="primary" @click="create" depressed :loading="sending">Přidat platbu</v-btn>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      valid: false,
      snackbar: false,
      inserted: false,
      items: [],
      item_init: { castka: null, mena_id: 1, variabilni_symbol: null, poznamka: null, protiucet: null, ucet_id: null },
      newItem: {},
      sending: false
    }
  },
  props: {
    id: String,
    program: String
  },
  mounted: function() {
    this.newItem = window.th.copy(this.item_init);
  },
  methods: {
    create () {
      this.sending = true;
      if (this.$refs.form.validate()) {
        window.API.post("platby", this.newItem).then(function(body) {
          if (body.inserted) {
            this.clear();
          }
          this.inserted = body.inserted;
          this.snackbar = true;
          this.sending = false;
        }.bind(this)).catch(function(err) {
          console.log(err);
          this.sending = false;
          this.inserted = false;
          this.snackbar = true;
        }.bind(this));
      }
    },
    clear () {
      this.newItem = window.th.copy(this.item_init);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/TestTools/NovaPlatba.vue